module.exports = __webpack_public_path__ + "static/media/mm_logo.02f05fd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm_logo.png
// module id = 2092
// module chunks = 0